import { inject, InjectionToken, Provider } from '@angular/core';

import { SideBarSignalState } from '../../types';
import { HANDLE_SIDE_BAR_SIGNAL_STORE } from '../signal-store';

export const SIDE_BAR_SIGNAL_STORE = new InjectionToken<SideBarSignalState>(
  'SIDE_BAR_SIGNAL_STORE',
);

export const SIDE_BAR_SIGNAL_PROVIDER: Provider = {
  provide: SIDE_BAR_SIGNAL_STORE,
  useClass: HANDLE_SIDE_BAR_SIGNAL_STORE,
};

export function sideBarTokenizer() {
  return inject(SIDE_BAR_SIGNAL_STORE);
}
